import React,{ useState, useContext, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import useCookie from "./../../hooks/useCookie";
import { CookieConsentContext } from "./../../utils/cookieconsent";
import {updateConsent} from "./../../utils/utilityFunctions";
import { Modal } from 'react-bootstrap';




import "./CookieBanner.scss";


const CookieBanner = ({data, showConsent}) => {
	const [userConsentCookie, setUserConsentCookie] = useCookie(process.env.GATSBY_USER_CONSENT_COOKIE);
	const [userCookie] = useCookie(process.env.GATSBY_USER_COOKIE);
	const [forcedConsent, setForcedConsent] = useContext(CookieConsentContext);		// eslint-disable-line no-unused-vars
	const [cookieToggle, setcookieToggle] = useState(showConsent?'show':'hide');
	const [isDisabled, setIsDisabled] = useState("")


	const logoImage = getImage(data.image.localFile.image);
	let eventLabel =  window.location.href;

	const closeCookieBanner= () => {
		

		if(typeof window === "undefined") {
			setForcedConsent(false)	
			setcookieToggle('hide');
		} else {
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		} 
	};

	const acceptConsent = () => {
		setIsDisabled('disabled');
		setUserConsentCookie(process.env.GATSBY_USER_CONSENT_COOKIE_ACCEPT)
		updateConsent(userCookie, process.env.GATSBY_USER_CONSENT_COOKIE_ACCEPT, 1)
		closeCookieBanner();		

	}

	const rejectConsent = () => {
		setIsDisabled('disabled');
		setUserConsentCookie(process.env.GATSBY_USER_CONSENT_COOKIE_REJECT);
		updateConsent(userCookie, process.env.GATSBY_USER_CONSENT_COOKIE_REJECT, 2)
		closeCookieBanner();	
	}


	return (
	<Modal show={cookieToggle}>
	
		<Modal.Body className="cookie-banner">
		<div className="cookie-content">
			<div className="cookie-image">
				<GatsbyImage image={logoImage} alt={data.image.alt?data.image.alt:"EE phonesmart"} className="consentLogo" />
			</div>
			<div className="cookie-content">
				<h4>{data.title}</h4>	
				<div dangerouslySetInnerHTML={{ __html: (data.description && data.description.html)?data.description.html:""}}></div>
			</div>
			<button id="cookieBannerAcceptCTA" className={`btn btn-highlight accept ${isDisabled}`} onClick={acceptConsent}
				data-analytics={`{ "event" : "cookieOverlay", "actionType" : "Accept", "loginStatus": "logged-out", "clickText" : "${data.accept_label}", "linkType" : "internal", "linkUrl" : "${eventLabel}", "pageName" : "Parent - Homepage" , "moduleName" : "Cookie policy - Engagement", "userType" : "anonymous" }`}>
					{data.accept_label}
			</button>
			<button id="cookieBannerRejectCTA" className={`btn btn-highlight noaccept ${isDisabled}`} onClick={rejectConsent}
				data-analytics={`{ "event" : "cookieOverlay", "actionType" : "Reject", "loginStatus": "logged-out", "clickText" : "${data.reject_label}", "linkType" : "internal", "linkUrl" : "${eventLabel}", "pageName" : "Parent - Homepage" , "moduleName" : "Cookie policy - Engagement", "userType" : "anonymous" }`}>
					{data.reject_label}
			</button>
			</div>
		</Modal.Body>
		
	</Modal>
		
		
	);
};

export default CookieBanner;
